<template>
  <v-btn
    color="red"
    class="no-decoration white--text text-caption"
    rounded
    dark
    @click="goSignInUI"
  >
    Google IDでサインイン
  </v-btn>
</template>

<script>
export default {
  methods: {
    goSignInUI () {
      const domain = `${process.env.VUE_APP_COGNITO_LOGIN_URL}`
      const clientId = `client_id=${process.env.VUE_APP_COGNITO_CLIENT_ID}`
      const responseType = 'response_type=token'
      const redirectUrl = `redirect_uri=${location.origin}/cb`
      const url = `${domain}?${clientId}&${responseType}&${redirectUrl}`
      window.location.href = url
    }
  }
}
</script>
